<template>
  <div class="inspection--page">
    <InspectionLoader v-if="apiLoading" />
    <InspectionNotFound v-if="displayInspectionError" />
    <InspectionDetail
      v-if="apiLoaded"
      :folderId="folderId"
      :hgShowAgreementsSuccess="hgShowAgreementsSuccess"
      :hgShowAgreementsWarning="hgShowAgreementsWarning"
      :forwarded-recipients="forwardedRecipients"
      :hg-forward-complete="forwardComplete"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import InspectionLoader from '@/components/Loaders/InspectionLoader.vue';
import InspectionDetail from '@/components/Inspection/InspectionDetail.vue';
import InspectionNotFound from '@/components/Inspection/InspectionNotFound.vue';

export default {
  extends: BaseViewComponent,
  components: {
    InspectionDetail,
    InspectionLoader,
    InspectionNotFound,
  },
  props: {
    forwardedRecipients: {
      type: Array,
      default: () => [],
    },
    forwardComplete: {
      type: Boolean,
      default: false,
    },
    folderId: {
      type: String,
      required: true,
    },
    hgShowAgreementsSuccess: {
      type: Boolean,
      default: false,
    },
    hgShowAgreementsWarning: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    await this.initialHydration();
  },
  computed: {
    ...mapState('User', ['currentUser']),
    displayInspectionError() {
      return !!(!this.apiLoading && this.apiError);
    },
  },
  data() {
    return {
      apiError: false,
      apiLoading: false,
      apiLoaded: false,
    };
  },
  methods: {
    ...mapActions('Inspection', ['loadInspection']),
    async initialHydration() {
      this.apiLoading = true;
      try {
        await this.loadInspection(this.folderId);
        this.apiLoaded = true;
      } catch (err) {
        this.apiError = true;
      }
      this.apiLoading = false;
    },
  },
};
</script>
